import { useQuery } from '@tanstack/react-query'
import pb from '@/lib/pb'
import { COLLECTIONS } from '@/types'
import type { TJob } from '@/types'
import { usePbSubscription } from '@/lib/usePbSubscription'

export function useJobs() {
  usePbSubscription(COLLECTIONS.JOBS, ['jobs'])
  return useQuery({
    queryKey: ['jobs'],
    queryFn: async () => {
      const records = await pb.collection(COLLECTIONS.JOBS).getFullList<TJob>({
        expand: 'tenant',
      })
      return records.sort((a, b) => {
        const aTime = a.created_at ? new Date(a.created_at.replace(' ', 'T')).getTime() : 0
        const bTime = b.created_at ? new Date(b.created_at.replace(' ', 'T')).getTime() : 0
        return bTime - aTime
      })
    },
  })
}

export function useJob(id: string) {
  return useQuery({
    queryKey: ['jobs', id],
    queryFn: async () => {
      const record = await pb.collection(COLLECTIONS.JOBS).getOne<TJob>(id)
      return record
    },
    enabled: !!id,
  })
}

export function useJobQueueSummary() {
  const { data: jobs = [], isLoading, isError } = useJobs()
  return {
    summary: {
      total: jobs.length,
      queued: jobs.filter((j: TJob) => j.status === 'queued').length,
      running: jobs.filter((j: TJob) => j.status === 'running').length,
      complete: jobs.filter((j: TJob) => j.status === 'complete').length,
      failed: jobs.filter((j: TJob) => j.status === 'failed').length,
    },
    jobs,
    isLoading,
    isError,
  }
}
